import React, { useContext } from "react";
import PropTypes from "prop-types";
import { PortionsContext } from "../context/PortionsContext";

const TwoColumns = (props) => {
  const { left, right, header, classContainer, rightClass } = props;
  const { clearSearch } = useContext(PortionsContext);

  const goToProfile = () => props.history.push(`${process.env.PUBLIC_URL}/profile`);
  const goBack = () => {
    clearSearch();

    props.history.goBack()
  };

  const headerWithProps = React.cloneElement(header, { goToProfile, goBack });

  return (
    <div className="home-background-image">
      <div className="home-background-color">
        {headerWithProps}

        <div className={classContainer || 'home-container'}>
          <div className="home-column home-column-left mobile-noDisplay">
            {left}
          </div>

          <div className={rightClass}>
            {right}
            <div className="home-politica">Política de Privacidad</div>
          </div>
        </div>
      </div>
    </div>
  )
}

TwoColumns.defaultProps = {
  rightClass: "home-column home-column-right",
}

TwoColumns.propTypes = {
  header: PropTypes.element.isRequired,
  left: PropTypes.element.isRequired,
  right: PropTypes.element.isRequired,
  rightClass: PropTypes.string,
  classContainer: PropTypes.string,
}

export default TwoColumns;
